const DEV_URL = "http://127.0.0.1:8000/api/";

const PRO_URL = "https://apiv2.shvesa.com/api/";

export const API_URL =
  process.env.NODE_ENV === "development" ? DEV_URL : PRO_URL;
